import { useEffect, useState } from "react";
import { errorNotify } from "../../services/toast.notification";
import { getLabBackupLog } from '../../api/api';
import Spinner from "../../components/_common/Spinner";
import './style.css'
import Table, { ColumnsType } from "antd/lib/table";
import './style.css'
import FormatFileSize from "../../components/_common/Format/FormatFileSize";

export interface InputProps {
  url: any
}

type Column = {
  title: string,
  dataIndex: string,
  key: string,
}

const LabBackupLogs = ({ url }: InputProps) => {

  // const columns: ColumnsType<any> = [
  //   { title: 'نام بانک', dataIndex: 'Str_DBName', key: 'Str_DBName' },
  //   { title: 'نوع ', dataIndex: 'Str_BackupType', key: 'Str_BackupType' },
  //   { title: 'سایز ', dataIndex: 'Str_BackupSize', key: 'Str_BackupSize' },
  //   { title: 'آخرین پذیرش', dataIndex: 'Int_LastReception', key: 'Int_LastReception' },
  //   { title: ' تاریخ', dataIndex: 'Str_StartDate', key: 'Str_StartDate' },
  //   { title: 'ساعت', dataIndex: 'Str_StartTime', key: 'Str_StartTime' },
  //   { title: 'آخرین فول', dataIndex: 'Str_FinishDate', key: 'Str_FinishDate' },
  //   { title: 'آدرس بکاپ', dataIndex: 'Str_DBBackupPath', key: 'Str_DBBackupPath' },
  //   { title: 'ارور', dataIndex: 'Str_ErrorLog', key: 'Str_ErrorLog' },
  //   { title: 'وضعیت', dataIndex: 'Int_Status', key: 'Int_Status' },
  // ];

  const columns: Column[] = [
    { title: 'نام بانک', dataIndex: 'Str_DBName', key: 'Str_DBName' },
    { title: 'نوع ', dataIndex: 'Str_BackupType', key: 'Str_BackupType' },
    { title: 'سایز ', dataIndex: 'Str_BackupSize', key: 'Str_BackupSize' },
    { title: 'آخرین پذیرش', dataIndex: 'Int_LastReception', key: 'Int_LastReception' },
    { title: ' تاریخ', dataIndex: 'Str_StartDate', key: 'Str_StartDate' },
    { title: 'ساعت', dataIndex: 'Str_StartTime', key: 'Str_StartTime' },
    { title: 'آخرین فول', dataIndex: 'Str_FinishDate', key: 'Str_FinishDate' },
    { title: 'آدرس بکاپ', dataIndex: 'Str_DBBackupPath', key: 'Str_DBBackupPath' },
    { title: 'ارور', dataIndex: 'Str_ErrorLog', key: 'Str_ErrorLog' },
    { title: 'وضعیت', dataIndex: 'Int_Status', key: 'Int_Status' },
  ];

  const [isLoading, setIsLoading] = useState(true);
  const [logs, setLogs] = useState([]);

  const [currentPage, setCurrentPage] = useState(1); //new
  const pageSize = 10; //new
  const totalPage = Math.ceil(logs.length / pageSize); //new
  const startIndex = (currentPage - 1) * pageSize; // new
  const currentData = logs.slice(startIndex, startIndex + pageSize); // new

  const _getBackuplog = (url: string, typeId: number, fromId: number) => {
    getLabBackupLog(url, typeId, fromId)
      .then((result: any) => {
        if (result.data.json != "{}") {
          let jsonResult = JSON.parse(result.data.json);
          setLogs(jsonResult.BackupLogs);
        }
        else
          setLogs([]);

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        errorNotify(error.response.data.errorMessage, undefined, 5000)
      })
  }

  useEffect(() => {
    _getBackuplog(url, 1, 0);
  }, [])

  return (
    <div className="tab-content-padding">
      {
        isLoading === false && (
          <>
            {
              logs.length > 0 && (
                <div className="card-table m-b-0">
                  <div className="thead thead-light">
                    <div className="tr" style={{ gridTemplateColumns: '10% 8% 9% 7% 7% 7% 7% 30% 8% 7%' }}>
                      {columns.map((item) => (
                        <div className="th text-center" key={item.key}>{item.title}</div>
                      ))}
                    </div>
                  </div>
                  <div className="tbody">
                    {currentData.map((log, index) => (
                      <div
                        className="tr"
                        style={{ gridTemplateColumns: '10% 8% 9% 7% 7% 7% 7% 30% 8% 7%' }}
                      >
                        {columns.map((item) => (
                          <div
                            className="td text-center"
                            key={item.key}
                            data-label={item.title}
                          >
                            {
                             
                              item.dataIndex === "Str_BackupSize"
                                ? FormatFileSize(Number(log[item.dataIndex]))
                                : log[item.dataIndex]
                            
                            }
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                  <div className="pagination">
                    <button className={'goToPage goFirst'} disabled={currentPage === 1} onClick={() => setCurrentPage(1)}></button>
                    <button className={'goToPage goPrev'} disabled={currentPage === 1} onClick={() => setCurrentPage((prev) => prev - 1)}></button>
                    {Array.from({ length: totalPage }, (_, i) => i + 1)
                      .filter((page) => {
                        if (currentPage <= 3)
                          return page <= 5;
                        if (currentPage >= totalPage - 2)
                          return page > totalPage - 5;
                        if (page >= currentPage - 2 && page <= currentPage + 2)
                          return page >= currentPage - 2 && page <= currentPage + 2;
                      })
                      .map((page) => (
                        <button type={'button'} key={page} className={page === currentPage ? "pageLink active" : "pageLink"} onClick={() => setCurrentPage(page)}>{page}</button>
                      ))}
                    <button className={'goToPage goNext'} disabled={currentPage === totalPage} onClick={() => setCurrentPage((prev) => prev + 1)}></button>
                    <button className={'goToPage goLast'} disabled={currentPage === totalPage} onClick={() => setCurrentPage(totalPage)}></button>
                  </div>
                </div>

              )
            }
            {
              !(logs.length > 0) &&
              (<p className="empty-data">داده ای برای نمایش موجود نیست.</p>)
            }
          </>
        )
      }
      {
        isLoading === true && (
          <Spinner />
        )
      }
    </div>

  )
}
export default LabBackupLogs;
{/*<Table scroll={{ x: "max-content" }}*/
}
{/*  dataSource={logs} columns={columns}*/ }
{/*/>*/ }
